import React, { useState, useEffect, useRef } from "react";
import DeleteImg from "assets/icons/delete.svg";
import ErrorImg from "assets/icons/error.svg";
import "./style.scss";

type Props = {
  id: number;
  type: "text" | "password";
  label: string;
  mt: number;
  index: number;
  isSubmit: boolean;
  firstInput?: string;
  secondInput?: string;
  error: string;
  setIndex: () => void;
  updateFirstInput?: (val: string) => void;
  updateSecondInput?: (val: string) => void;
};

export const FormInput: React.FC<Props> = ({
  id,
  type,
  label,
  mt,
  index,
  isSubmit,
  firstInput,
  secondInput,
  error,
  setIndex,
  updateFirstInput,
  updateSecondInput,
}) => {
  const [inputClicked, setInputClicked] = useState<boolean>(false);
  const [submitClicked, setSubmitClicked] = useState<boolean>(false);
  const [inputVal, setInputVal] = useState<string>("");
	let nameInput;

  useEffect(() => {
    setInputClicked(id == index ? true : false);
    setSubmitClicked(isSubmit);
  }, [index, isSubmit]);

  const onInputChange = (val) => {
    setInputVal(val); // child state update
    if (updateFirstInput) {
      // parent state update
      updateFirstInput(val);
    }
    if (updateSecondInput) {
      updateSecondInput(val);
    }
  };

  const onInputClick = () => {
    setInputClicked(true); // set input to active
    setIndex(); // update current clicked field
  };

  const onInputDelete = () => {
    setInputVal(""); // delete child input
    if (updateFirstInput) {
      // delete parent input
      updateFirstInput("");
    }
    if (updateSecondInput) {
      updateSecondInput("");
    }
    setInputClicked(false);
  };

  return (
    <div>
      <div
        className={inputClicked ? "form-input focused" : "form-input"}
        style={{ marginTop: mt }}
      >
        <div
          className="form-input-container"
          onClick={() => {
						nameInput.click();
						nameInput.focus();
          }}
        >
          {/* upper label */}
          {inputVal != "" && <span className="form-input-label">{label}</span>}
          <div style={{ position: "relative" }}>
            <input
              type={type}
              ref={input => nameInput = input}
              value={inputVal}
              onChange={(e) => {
                onInputChange(e.target.value);
              }}
							onClick={() => {
								onInputClick();
							}}
            ></input>
            {/* input placeholder */}
            {inputVal == "" && (
              <span className="form-input-placeholder">{label}</span>
            )}
          </div>
        </div>
        {/* delete icon */}
        {inputClicked && (
          <img
            src={DeleteImg}
            alt="delete"
            onClick={() => {
              onInputDelete();
            }}
          />
        )}
      </div>
      {/* if input value is null after submit clicked */}
      {submitClicked && inputVal == "" && (
        <div className="error-container">
          <img src={ErrorImg} alt="error" />
          <span className="error-label">{error}</span>
        </div>
      )}
    </div>
  );
};
